export const ROLES = {
    OWNER: '08da3f0d-0371-4dd3-8c86-e51222d56188',
    USER: '08da3f0d-0371-4dd3-8c86-e51222d56189',
    MANAGER: '08da3f0d-0371-4dd3-8c86-e51222d56190',
    VIEWER: '08da3f0d-0371-4dd3-8c86-e51222d56191',
    SUPER_ADMIN: '08da3f0d-0371-4dd3-8c86-e51222d56192'
}

export const isRole = (roles) => {
    const userRole = window.localStorage.getItem("roleid");
    const type = typeof roles;
    if (userRole) {
        if (type === "string") {
            return roles == userRole;
        }
        if (type === "object") {
            return roles.includes(userRole);
        }
    }
    return false;
}

export const isNotRole = (roles) => {
    const userRole = window.localStorage.getItem("roleid");
    const type = typeof roles;
    if (userRole) {
        if (type === "string") {
            return roles != userRole;
        }
        if (type === "object") {
            return !roles.includes(userRole);
        }
    }
    return true;
}